var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.role)?_c('span',{staticClass:"membership-badge",attrs:{"data-cy":"membership-badge"}},[_vm._v(" "+_vm._s(_vm.role)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }